import wxsdk from "@/global/wxsdk"
import {getWxShare} from "../src/request/api";

/**
 * @name: 匿名函数监听
 * @param {Object} obj 监听对象
 * @param {String} type 监听类型
 * @param {Function} callback 回调
 */
// 添加监听
// this.listen = myListener("click", () => {});
// 移除监听
// this.listen()
const myListener = (obj, type, callback, toggle = false) => {
    obj.addEventListener(type, callback, toggle);
    return () => {
        obj.removeEventListener(type, callback, toggle);
    };
};

/**
 * @name: 字数省略
 * @param {String} elem 元素节点
 * @param {String, Number} max 最大长度
 * @param {String} str 替换符号
 */
const cutString = (text, max, str = "...") => {
    if (text > max) {
        return max + str;
    } else {
        return text;
    }
};

/**
 * @name: 获取cookie
 * @param {type}
 */
// 调用
// var cookie_value = getCookie(cookie_name);
const getCookie = function (cookie_name) {
    var allcookies = document.cookie;
    //索引长度，开始索引的位置
    var cookie_pos = allcookies.indexOf(cookie_name);
    // 如果找到了索引，就代表cookie存在,否则不存在
    if (cookie_pos != -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + cookie_name.length + 1;
        //计算取cookie值得结束索引
        var cookie_end = allcookies.indexOf(";", cookie_pos);
        if (cookie_end == -1) {
            cookie_end = allcookies.length;
        }
        //得到想要的cookie的值
        var value = unescape(allcookies.substring(cookie_pos, cookie_end));
    }
    return value;
}
// 微信二次分享
const wx_secendShare = function(s_title, s_desc, s_image, s_url) {
    getWxShare({url: location.href}).then(res => {
        if (res.error_code == 0) {
            wx.config({
                debug: false,
                appId: res.appId,
                timestamp: res.time.toString(),
                nonceStr: res.noncestr,
                signature: res.signature,
                jsApiList: [
                    'onMenuShareTimeline', //分享到朋友圈
                    'onMenuShareAppMessage' //分享给微信好友
                ],
                openTagList:['wx-open-launch-app']
            });
            wx.onMenuShareTimeline({ //分享到朋友圈
                title: s_title || "知东莞", // 分享标题
                link: s_url || location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                desc: s_desc || "更多精彩内容请下载知东莞APP", // 分享描述
                // imgUrl: s_image || store.state.vuex_shareConfig.image, // 分享图标
                imgUrl: s_image, // 分享图标
                success: function () {
                    // 用户确认分享后执行的回调函数
                    // uni.showToast({
                    //     title: "分享成功",
                    //     icon: "none"
                    // })
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                    // uni.showToast({
                    //     title: "你还没分享哦",
                    //     icon: "none"
                    // })
                }
            });
            wx.onMenuShareAppMessage({ // 分享给朋友
                title: s_title || "知东莞", // 分享标题
                // desc: s_desc || "讲党性，树新风，重实干，促发展", // 分享描述
                // desc: s_desc || "", // 分享描述
                desc: s_desc || "更多精彩内容请下载知东莞APP", // 分享描述
                link: s_url || location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                // imgUrl: s_image || store.state.vuex_shareConfig.image, // 分享图标
                imgUrl: s_image, // 分享图标
                type: "", // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function () {
                    // 用户确认分享后执行的回调函数
                    // uni.showToast({
                    //     title: "分享成功",
                    //     icon: "none"
                    // })
                },
                cancel: function () {
                    // 用户取消分享后执行的回调函数
                    // uni.showToast({
                    //     title: "你还没分享哦",
                    //     icon: "none"
                    // })
                }
            });
        }
    })
}

export { myListener, cutString, getCookie, wx_secendShare };
